import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/produce-craft/update/paramters`,
    name: 'PARAM_UPDATE',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
